/**
 * 캔버스/문서 편집 모달(활동지·평가지 캔버스·기준안 웹 문서 등)이 열려 있거나
 * 키 이벤트가 모달 안에서 났으면 true → 뒤쪽 페이지의 전역 키 단축키(Backspace 삭제 등)는 무시해야 함.
 */
const EDITOR_MODAL_SELECTOR =
  '.cp-evaluation-plan-sheet-canvas-backdrop, .cp-evaluation-plan-web-doc-backdrop, .cp-learning-worksheet-editor-backdrop';

export function isCanvasEditorModalOpen(): boolean {
  if (typeof document === 'undefined') return false;
  return !!document.querySelector(EDITOR_MODAL_SELECTOR);
}

export function shouldOuterPageIgnoreKey(e: KeyboardEvent): boolean {
  if (isCanvasEditorModalOpen()) return true;
  const t = e.target;
  return t instanceof Element && !!t.closest(EDITOR_MODAL_SELECTOR);
}
